import {sixYardAxios} from "../../sixYardAxios";
import * as actionTypes from "./action_types";


export const fetchUserInfoSuccess = data => {
  return {
    type: actionTypes.SET_USER_PROFILE,
    data
  };
};
export const saveGeneralInformationSuccess = data => {
  return {
    type: actionTypes.SET_USER_PROFILE,
    data
  };
};
export const clearProfileError=()=>{
  return {
    type:actionTypes.CLEAR_USER_PROFILE_ERROR
  }
}
const fetchUserInfoFailed=()=>{
  return {
    type:actionTypes.ERROR_FETCH_USER_PROFILE
  }
}
export const fetchUserProfile = () => {
  return (dispatch,getState) => {
    const state = getState();
    sixYardAxios({
        url: "/profile"})
        .then(response => {
          dispatch(fetchUserInfoSuccess(response.data.data));
        })
        .catch(error => {
          if (localStorage.getItem("token") && error.response.status === 401) window.location('/logout') /*check it*/
        dispatch(fetchUserInfoFailed())
        });
  };
};

// to be removed
export const SaveGeneralInformation = (data,language) => {
  return (dispatch) => {
    sixYardAxios({
      method: "put",
      url: "user?language="+language,
      data: data})
      .then(response => {
        dispatch(fetchUserInfoSuccess(response.data.data));
      })
      .catch(error => {});
  };
};
